import * as types from './mutations-types'
import pointsMailApi from '../../../../../api/wx-member/points-mall/points-mall'
import dictApi from '../../../../../api/dict/dictionary-api'
import FormatTableFieldUtils from '../../../../../common/utils/format-table-field-util'
import * as DictionaryConstants from '../../../../../constants/DictionaryConstants'
import * as DataTypeConstants from '../../../../../constants/DataTypeConstants'

export default {
  getMemberOrder: ({ commit }, data) => {
    dictApi.getAllOrgs().then(res => {
      pointsMailApi.getMemberOrder(data)
        .then(result => {
          result.dataList.filter(item => {
            item.departmentList = []
            // console.log(item, 'itemcommodityRelDepartmentDTOListcommodityRelDepartmentDTOListcommodityRelDepartmentDTOList')
            // item.commodityRelDepartmentDTOList.filter(itemTwo => {
            //   res.filter(itemThree => {
            //     if (itemTwo.departmentId === itemThree.value) {
            //       item.departmentList.push(itemThree)
            //     }
            //   })
            // })
          })
          let params = [
            {
              fieldDataType: DataTypeConstants.FORMAT_TABLE_DICT,
              fieldPropCode: 'comprehensiveStatus',
              fieldPropName: 'comprehensiveStatusName',
              fieldFormatParam: DictionaryConstants.MY_ORDER_STATUS
            }
          ]
          FormatTableFieldUtils.formatTableFieldName(result.dataList, params).then(res => {
            result.dataList = res
            commit(types.MY_ORDER_LIST, result)
          })
        })
    })
  },
  deleteOrderById: ({ commit }, data) => {
    return new Promise(resolve => {
      pointsMailApi.deleteOrderById(data)
        .then(result => {
          resolve(result)
        })
    })
  },
  closeOrderById: ({ commit }, data) => {
    return new Promise(resolve => {
      pointsMailApi.closeOrderById(data)
        .then(result => {
          resolve(result)
        })
    })
  }
}



// WEBPACK FOOTER //
// ./src/pages/wx-member/points-mall/my-order/store/actions.js